<template>
  <MultiFileDirectUploader
    :file-badge-position="showBelow"
    :accept="accept"
    :on-file-uploaded="handleFileUploadedTest"
    :on-file-removed="handleFileRemoved"
    :on-file-upload-progress="onFileUploadProgress"
    :on-all-files-uploaded="onAllFilesUploaded"
  >
    <div class="row-fluid">
      <div class="span3" />
      <div class="span6">
        <div class="document-uploader-main-tip">
          {{ I18n.t('components.document.uploader.upload_to_silverfin') }}
        </div>
      </div>
      <div class="span3">
        <a
          v-if="filesUploaded"
          class="
            document-uploader-btn document-uploader-btn-secondary
            dz-clickable
          "
        >
          {{ I18n.t('components.document.uploader.upload_more') }}
        </a>
      </div>
    </div>
    <p
      v-if="filesUploaded"
      v-dompurify-html="
        I18n.t('components.document.uploader.uploaded_files', {
          count_behaviour: count,
        })
      "
    />
    <p
      v-else
      v-dompurify-html="
        I18n.t('components.document.uploader.upload_multiple_files')
      "
    />

    <div style="text-align: center">
      <a
        v-if="!filesUploaded"
        class="document-uploader-btn document-uploader-btn-primary"
      >
        {{ I18n.t('components.document.uploader.upload_files') }}
      </a>
    </div>
  </MultiFileDirectUploader>
</template>

<script>
import MultiFileDirectUploader from '@app/shared/vue/components/direct-upload/multi-file-direct-uploader'
import { SHOW_BELOW } from '@app/shared/vue/components/direct-upload/constants'

export default {
  name: 'PulseFilesUploader',

  components: {
    MultiFileDirectUploader,
  },

  props: {
    accept: {
      type: String,
      default: '',
    },
    onAllFilesUploaded: {
      type: Function,
      default: () => {},
    },
    onFileRemoved: {
      type: Function,
      default: () => {},
    },
    onFileUploaded: {
      type: Function,
      default: () => {},
    },
    onFileUploadProgress: {
      type: Function,
      default: () => {},
    },
  },

  data: function () {
    return {
      count: 0,
    }
  },

  computed: {
    filesUploaded() {
      return this.count > 0
    },
    showBelow() {
      return SHOW_BELOW
    },
  },

  methods: {
    handleFileUploadedTest(file, uuid, count) {
      this.onFileUploaded(file, uuid)
      this.count = count
    },
    handleFileRemoved(uuid, count) {
      this.onFileRemoved(uuid)
      this.count = count
    },
  },
}
</script>
